<template>
  <section class="hero is-fullheight">
    <div class="hero-body">
      <div class="container">
        <div class="columns is-centered">
          <div class="column is-half center">
            <div class="card">
              <header class="card-header">
                <p class="card-header-title">{{ $t("login.titleLogin") }}</p>
              </header>
              <div class="card-content">
                <form @submit.prevent @keyup.enter="validateBeforeLogin">
                  <b-field :label="$t('form.fieldEmail')">
                    <b-input
                      type="email"
                      v-model="login.email"
                      :placeholder="$t('form.fieldEmail')"
                      :validation-message="$t('error.incorrectEmail')"
                      required
                    >
                    </b-input>
                  </b-field>

                  <b-field :label="$t('form.fieldPassword')">
                    <b-input
                      type="password"
                      v-model="login.password"
                      :placeholder="$t('form.fieldPassword')"
                      :validation-message="$t('error.incorrectPassword')"
                      password-reveal
                      required
                    >
                    </b-input>
                  </b-field>

                  <language-switch></language-switch>

                  <b-button
                    class="button is-primary"
                    :disabled="loading"
                    :loading="loading"
                    @click="validateBeforeLogin"
                    >{{ $t("button.login") }}</b-button
                  >
                  <div>
                    {{ $t("login.noAccount") }}

                    <router-link to="/signup">
                      {{ $t("login.linkCreateAccount") }}</router-link
                    >
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import firebase from "firebase/app";
import toast from "@/mixins/toast";

import LanguageSwitch from "@/components/LanguageSwitch.vue"

export default {
  mixins: [toast],
  components: {
    LanguageSwitch
  },
  name: "login",
  data() {
    return {
      login: {
        email: "",
        password: ""
      },
      loading: false
    };
  },
  methods: {
    validateBeforeLogin() {
      if (!this.login.email || !this.login.password) {
        this.showInvalidForm();
        return;
      }
      this.loginUser();
    },
    loginUser() {
      this.loading = true;
      firebase
        .auth()
        .signInWithEmailAndPassword(this.login.email, this.login.password)
        .then(
          response => {
            this.loading = false;
            this.showValidlogin();
            this.$store.dispatch(
              "authentication/setAuthenticatedUser",
              response.user
            );
            this.$router.push("overview");
          },
          error => {
            this.loading = false;
            this.showInvalidlogin(error);
          }
        );
    },
    showInvalidForm() {
      this.showErrorToast(this.$t("notifications.errorFillInAllFields"));
    },
    showValidlogin() {
      this.showSuccessToast(this.$t("notifications.successLogin"));
    },
    showInvalidlogin(error) {
      this.showErrorToast(error || this.$t("notifications.errorLogin"));
    }
  },
  beforeCreate() {
    // TODO better manage adding this class and removing it in month
    document.body.classList.add("radiant-background");
  }
};
</script>

<style lang="scss"></style>
